import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddExerciseOptionFormValidation(t: TFunction) {
  return yup.object({
    nameKey: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameKeyRequired')),
    unitKey: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.unitKeyRequired')),
    type: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.typeRequired')),
    priorityOrder: yup
      .number()
      .min(1, t('formikValidation.minValue').replace('{0}', '1'))
      .required(t('formikValidation.orderRequired')),
  });
}
